S.listPublication = {
    config: {
        filter: 0,
        action: 'list',
    },

    elements: {
        $filterHead: null,
        $filterItem: null,
        $listContainer: null,
        $loadButton: null,
        $showAllFilter: null,
        $button: null,
        $teaser: null,
        $filter: null,
        $currentFilter: null,
        $activeType: null,
    },

    originFilter: [],
    currentFilter: [],
    page: null,
    renewList: true,
    reset: false,

    init()
    {
        this.elements.$filterHead.on('click', (element) =>
        {
            this.elements.$filterHead.not(element.currentTarget).removeClass('is-open');
            this.elements.$filterHead.not(element.currentTarget).children().removeClass('is-open');

            $(element.currentTarget).toggleClass('is-open');
            $(element.currentTarget).children().toggleClass('is-open');
        });

        if (!this.page)
        {
            this.page = 2;
        }
        this.originFilter['type'] = this.elements.$listContainer.data('type');

        this.elements.$loadButton.on('click', () =>
        {
            this.renewList = false;
            this.loadPublications();
            this.page++;
        });

        this.initFilters();
    },

    loadPublications()
    {
        const container = this.elements.$listContainer;
        const loadButton = this.elements.$loadButton;
        const ajaxUrl = container.attr('data-ajaxUrl');
        const storagePid = container.attr('data-storagepid');
        const data = {};

        data['tx_project_publication[page]'] = this.page;
        const typeValue = this.checkFilter().slice(0, -1);
        if (typeValue) {
            data['tx_project_publication[type]'] = typeValue;
        }
        data['tx_project_publication[more]'] = true;
        data['tx_project_publication[storagePid]'] = storagePid;
        data['tx_project_publication[reset]'] = this.reset;

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: data,
            cache: false,
            success: (data) =>
            {
                // HTML Output
                if (this.renewList)
                {
                    container.html($(data).find('.m-main').html());
                    this.page++;
                }
                else
                {
                    container.append($(data).find('.m-main').html());
                }
                if ($(data).find('.m-load-button').hasClass('is-hidden'))
                {
                    loadButton.hide();
                }
                else
                {
                    loadButton.show();
                }
            },
            error: (e) =>
            {
                // eslint-disable-next-line no-console
                console.log(e, 'error');
            },
        });
    },

    initFilters()
    {
        this.elements.$filterItem.on('click', (element) =>
        {
            this.page = 1;
            this.renewList = true;
            this.currentFilter.push($(element.currentTarget).attr('data-uid'));

            this.displayFilter();
        });
    },

    resetFilter()
    {
        this.currentFilter = [];
        this.page = 1;
        this.reset = true;
        this.elements.$listContainer.data('type', this.originFilter['type']);


        this.loadPublications();
    },

    displayFilter()
    {
        const currentFilter = Object.assign({}, this.currentFilter);

        this.elements.$currentFilter.html('');
        $.each(currentFilter, (key, value) =>
        {
            this.elements.$currentFilter.append('<p class="m-active-type js-active-type" data-name="type" data-uid="' + value + '" >' + $('.m-item.js-filter-item[data-uid=' + value + ']').text() + '</p>');
        });


        this.filterEnabled();
    },

    filterEnabled()
    {
        this.currentFilter = [];
        this.elements.$currentFilter.children().before().on('click', (e) =>
        {
            $(e.currentTarget).remove();
            this.page = 1;
            this.renewList = true;
            this.filterEnabled();
        });

        this.elements.$currentFilter.children().each((index) =>
        {
            this.reset = false;
            this.currentFilter.push(this.elements.$currentFilter.children().eq(index).attr('data-uid'));
        });

        if (Object.keys(this.currentFilter).length === 0)
        {
            this.resetFilter();
        }
        else
        {
            this.loadPublications();
        }
    },

    getRightValue(item)
    {
        if (item)
        {
            return item;
        }

        return '0';
    },

    checkFilter()
    {
        this.checkDuplicated();
        if (Object.keys(this.currentFilter).length === 0)
        {
            return '';
        }
        let value = '';

        this.currentFilter.forEach(function (item)
        {
            value += item + ',';
        });

        return value;
    },

    checkDuplicated()
    {
        var testarray = [];

        this.elements.$currentFilter.children().each((index) =>
        {
            if (testarray.indexOf(this.elements.$currentFilter.children().eq(index).data('uid')) === -1)
            {
                testarray.push(this.elements.$currentFilter.children().eq(index).data('uid'));
            }
            else
            {
                this.elements.$currentFilter.children().eq(index).remove();
            }
        });
    },
};
